import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from '../components/layout/Header/Header';
import Hero from '../pages/Home/Hero/Hero';
import Simulator from '../pages/Home/Simulator/Simulator';
import Stats from '../pages/Home/Stats/Stats';
import Services from '../pages/Home/Services/Services';
import Benefits from '../pages/Home/Benefits/Benefits';
import About from '../pages/Home/About/About';
import Contact from '../pages/Home/Contact/Contact';
import Footer from '../components/layout/Footer/Footer';
import PartnersGrid from '../components/common/PartnersGrid/PartnersGrid';
import Partners from '../pages/Partners/Partners';
import ToS from '../pages/TermsOfService/ToS';
import WhatsAppButton from '../components/common/WhatsAppButton/WhatsAppButton';
import BackToTopButton from '../components/common/BackToTopButton/BackToTopButton';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div>
            <Header />
            <WhatsAppButton />
            <BackToTopButton />
            <main>
              <Hero />
              <PartnersGrid />
              <Simulator />
              <Benefits />
              <Services />
              <Stats />
              <About />
              <Contact />
            </main>
            <Footer />
          </div>
        } />
        
        <Route path="/termos-servico" element={
          <div>
            <Header />
            <main>
              <ToS />
            </main>
            <Footer />
          </div>
        } />

        <Route path="/parceiros" element={
          <div>
            <Header />
            <main>
              <PartnersGrid />
              <Partners />
            </main>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;